import '../../assets/css/typography.css';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ScrollingProvider } from 'react-scroll-section';
import Helmet from './Helmet';
import { Flex, Box } from 'rebass/styled-components';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import theme from '../../theme';

const GlobalStyle = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: inherit;
    }

  body {
    box-sizing: border-box;
    margin: 0;
    font-family: SpaceGrotesk-Bold, sans-serif;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    font-display: swap;
    line-height: 1.31;
    letter-spacing: 0.4px;
    color: #535353;
  }
  
  a {
    color: #646A6B;
    text-decoration: underline;
    padding: 0 5px 0 5px;
  }

  *:focus {
    outline: none;
  }

`;

const Layout = ({ children }) => {
  return (
    <Fragment>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <ScrollingProvider>
          <Helmet />
          <Flex flexDirection="column" bg="screenBackground" height="100vh">
            <Box width={1}>{children}</Box>
          </Flex>
        </ScrollingProvider>
      </ThemeProvider>
    </Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
